module.exports = __webpack_public_path__ + "55d50af05638e9dd0a4bb545b3909e09.png";